import React, {useEffect, useState} from 'react'
import { Switch } from '@headlessui/react'
import cx from 'classnames'

const Toggle = props => {
    const [enabled, setEnabled] = useState(props.enabled ?? false)

    const onChange = () => setEnabled(!enabled)

    useEffect(() => {
        if (props.onChange) {
            props.onChange(enabled)
        }
    }, [enabled])

    return (
        <div className={'flex items-center gap-2'}>
            <Switch
                checked={enabled}
                onChange={onChange}
                className={cx('relative inline-flex h-6 w-10 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75', {
                    'bg-indigo-700': enabled,
                    'bg-gray-300': !enabled
                })}
            >
                <span className="sr-only">Use setting</span>
                <span
                    aria-hidden="true"
                    className={
                    cx('pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out', {
                        'translate-x-4': enabled,
                        'translate-x-0': !enabled
                    })}
                />
            </Switch>
            {
                props.label ?
                    <p onClick={onChange} className={'text-gray-600 text-sm tracking-wide'}>
                        {props.label}
                    </p>
                    : null
            }
        </div>
    )
}

export default Toggle